import { getContext, call, put, takeEvery } from 'redux-saga/effects';
import { getCacheKey } from 'next/lib/caching';
import { patterns as flowPatterns } from 'next/entities/flows';
import { queryFlowsMetricsAnalytics } from 'next/client/queries';
import { append, reject, readOne } from './actions';

export function* getAnalytics({ payload: { query } }) {
  try {
    const api = yield getContext('api');
    const { results } = yield call(api.getAnalytics, query);
    const key = getCacheKey(query);
    yield put(append({ [key]: results }));
  } catch (error) {
    yield put(reject(error));
  }
}

export function* getFlowAnalytics() {
  const query = queryFlowsMetricsAnalytics();
  const readAction = readOne({ query });
  yield call(getAnalytics, readAction);
}

export default function* analyticsSagas() {
  yield takeEvery(flowPatterns.read, getFlowAnalytics);
}
